import styled from "styled-components";

export const StyledLabel = styled.span`
  color: #606060;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

export const StyledValue01 = styled.span`
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const StyledPlaceholder = styled.div`
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  display: flex;
`;

export const StyledValue = styled.div`
  align-self: stretch;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  display: inline-flex;
`;

export const StyledSelectopendown = styled.div`
  width: 24px;
  height: 24px;
  left: 0px;
  top: 0px;
  position: absolute;
  overflow: hidden;
`;

export const StyledContent = styled.div`
  flex: 1 1 0;
  padding-left: 8px;
  padding-right: 4px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
`;

export const StyledInteractiveIcon = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
`;

export const StyledDropdown = styled.div`
  width: 169px;
  height: 48px;
  padding: 8px;
  background: white;
  outline: 1px #e9e9e9 solid;
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
  position: relative;
  cursor: pointer;
`;
export const StyledContainer = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

export const StyledNavigation = styled.div`
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  display: flex;
`;

export const StyledInputmaster = styled.div`
  flex: 1 1 0;
  overflow: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  display: inline-flex;
`;

export const StyledFrame1010107270 = styled.div`
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-right: 32px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
`;

export const DropDownListContainerStyled = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  background: #fff;
  box-shadow: 0 0 3px #e9e9e9;
  border-radius: 0 0 4px 4px;
  z-index: 10;
`;

export const DropDownListStyled = styled.ul`
  margin: 0;
  background: #fff;
  box-shadow: 0 0 3px #e9e9e9;
  box-sizing: border-box;
  color: #1b1b1b;
  font-weight: normal;
  font-size: 16px;
  border-radius: 4px;
  height: 100%;
  padding: 8px 0;
  max-height: 400px;
  overflow: auto;
`;

export const ListItemStyled = styled.li`
  list-style: none;
  padding: 8px 16px;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  align-items: center;
  cursor: pointer;
  opacity: 1;
  transition: all 0.2s;
  &:hover {
    opacity: 0.8;
    background-color: #f5f5f5;
  }
`;

export const MissionListActionsContainer = StyledContainer;
export const MissionListActionsSearchContainer = styled.div`
  align-self: stretch;
  height: 48px;
  padding-left: 32px;
  padding-right: 32px;
  position: relative;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
`;
export const MissionListActionsRoot = StyledFrame1010107270;
export const MissionListActionsSearchIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const MissionListActionsInputMaster = StyledInputmaster;
export const MissionListActionsInputContent = styled.div`
  flex: 1 1 0;
  padding-left: 12px;
  padding-right: 12px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
  z-index: 2;
`;
export const MissionListActionsLabel = styled.span`
  color: #606060;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;
export const MissionListActionsNavigation = StyledNavigation;
export const MissionListActionsPlaceholder = styled.div`
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  display: flex;
`;
export const MissionListActionsStateOverlay = styled.div`
  width: 100%;
  height: 48px;
  left: 0px;
  top: 0px;
  position: absolute;
  opacity: 0.5;
  background: #e9e9e9;
  pointer-events: none;
`;
export const MissionListActionsSearchBox = styled.div`
  width: 24px;
  height: 24px;
  left: 0px;
  top: 0px;
  position: absolute;
  overflow: hidden;
`;
export const MissionListActionsSearchIconShape = styled.div`
  width: 18.21px;
  height: 18.21px;
  left: 3px;
  top: 3px;
  position: absolute;
`;

export const MissionListActionsInput = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  font-size: 16px;
  color: #1b1b1b;
  outline: none;
  font-family: Readex Pro, sans-serif;
  z-index: 2;
`;
